import React from "react";
// 
import {  IconButton,  Tooltip } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import{IconShuffle, IconRedo, IconUndo} from '../static/DimIcons'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    marginTop: '10px',
    marginLeft: '10px',
    marginRight: '10px',
    border: '2px solid',
    width: theme.spacing(8),
    height: theme.spacing(8),
    fontSize: "large",
  },
  box: {
    display: 'flex',
    
  },
}));

export default function ShuffleUndo(props) {
  const { shuffleFunc, setUndoTrigger, setRedoTrigger } = props;
  const classes = useStyles();


  const HandleShuffle = (event) => {
    shuffleFunc()
    event.preventDefault()
    event.stopPropagation()
  };

  const HandleUndo = () => {
    console.log('undo pressed')
    setUndoTrigger(true)
  }

  const HandleRedo = () => {
    console.log('redo pressed')
    setRedoTrigger(true)
  }


  return (

    <div className={classes.box} >
    <Tooltip title={"shuffle"} arrow>
    <IconButton className={classes.root} key={10} color="primary" onClick={HandleShuffle} ><IconShuffle/> </IconButton>
    </Tooltip>
    <Tooltip title={"undo"} arrow>
    <IconButton  className={classes.root} key={11}  onClick={HandleUndo}><IconUndo /> </IconButton>
    </Tooltip>
    <Tooltip title={"Redo"} arrow>
    <IconButton  className={classes.root} key={12}  onClick={HandleRedo}><IconRedo /> </IconButton>
    </Tooltip>
    </div>
    
    )
}
